var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPointer = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.997 6.563c0 2.878 3.494 6.01 5.003 7.227 1.509-1.217 5.004-4.35 5.004-7.227 0-2.558-2.245-4.64-5.004-4.64-2.76 0-5.003 2.082-5.003 4.64m-.997 0C2 3.495 4.693 1 8 1s6 2.495 6 5.563c0 3.412-3.973 6.863-5.68 8.188L8 15l-.32-.248C5.973 13.426 2 9.974 2 6.562M7 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPointer);
export default ForwardRef;